import React from 'react';
import Icon from 'src/components/Icon/shared/icons/ok.svg';

export const CONFIGURED = 'configured';
export const DEALER = 'dealer';
export const FINANCE = 'finance';
export const ORDERED = 'ordered';
export const MY_INFORMATION = 'my_information';
export const PAYMENT = 'payment';
export const BASKET = 'basket';

export interface IDealStep {
    done: undefined | boolean;
    text: string;
    id: string;
}

const renderStep = (id: string, done: undefined | boolean, text: string) => {
    const classIcon = done === undefined ? 'none' : done ? 'ok' : 'attention';
    return (
        <li key={id} className="step-container" data-testid={`TESTING_DEAL_${id}`}>
            <img src={`data:image/svg+xml;charset=UTF-8,${Icon}`} alt="" className={`icon ${classIcon}`} />
            <span className={`text ${classIcon}`}>{text}</span>
        </li>
    );
};

export const renderDealStepsFlow = (dealSteps: IDealStep[]) => {
    const ulClassName = dealSteps.length > 1 ? 'timeline' : null;
    return (
        <div className="deal-steps-flow">
            <ul className={ulClassName}>
                {dealSteps.map((dealStep: IDealStep) => renderStep(dealStep.id, dealStep.done, dealStep.text))}
            </ul>
        </div>
    );
};
